import React, { useRef } from "react"
import GTM from "@src/services/gtm"
import styled from "styled-components"
import Toc from "@src/components/terms-and-conditions/toc"
import ResponsiveSection from "@src/components/container-responsive-section"
import theme from "@src/styles/theme"
import BreadCrumbs from "@src/components/breadcrumbs"
import PropTypes from "prop-types"

const TAndCStyle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  padding-bottom: 76px;
  padding-top: 76px;
`

const ContentHolder = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 37px;
  position: relative;
`

const LegalHolder = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 68%;

  p {
    color: ${theme.gray500};
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0.5px;
  }
  ul {
    list-style-type: disc;
    padding-left: 20px;
    color: ${theme.gray500};
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0.5px;
  }

  ul ul {
    list-style-type: circle;
    padding-left: 20px;
    color: ${theme.gray500};
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0.5px;
  }
  h2 {
    margin-top: 24px;
    color: ${theme.gray900};
    font-size: 26px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px;
    letter-spacing: 0.5px;
  }

  @media (max-width: 600px) {
    width: 100%;

    h2 {
      font-size: 22px;
      font-weight: 700;
      line-height: 30px;
      letter-spacing: 0.55px;
    }
  }
`
const Separator = styled.div`
  width: 100%;
  height: 1px;
  flex-shrink: 0;
  margin-bottom: 40px;
  background: ${theme.gray200};
`

const Title = styled.div`
  color: ${theme.gray900};
  font-size: 46px;
  font-style: normal;
  font-weight: 900;
  line-height: 64px;
  letter-spacing: 0.5px;
  margin-bottom: 32px;
  @media (max-width: 600px) {
    font-size: 32px;

    font-weight: 700;
    line-height: 44px;
    letter-spacing: 0.5px;
  }
`

const Date = styled.div`
  color: ${theme.secondary500};
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  margin-bottom: 8px;
`

const PageStaticTermsAndConditions = ({ title, html }) => {
  const contentRef = useRef(null)
  const firstParagraphMatch = html.match(/<p>(.*?)<\/p>/)
  const lastUpdate = firstParagraphMatch
    ? firstParagraphMatch[1].replace(/<[^>]*>/g, "")
    : ""

  const formatHtml = html
    .replace(firstParagraphMatch[0], "")
    .replace(/<h2>/g, (match, index) => `<h2 id="toc-${index}">`)

  GTM.dataLayerPushPageInfo({
    template: "static-about-us",
  })
  return (
    <>
      <ResponsiveSection>
        <BreadCrumbs />
      </ResponsiveSection>
      <ResponsiveSection>
        <TAndCStyle>
          <Date>{lastUpdate}</Date>
          <Title>{title}</Title>
          <Separator />
          <ContentHolder>
            <Toc refference={contentRef} />
            <LegalHolder
              ref={contentRef}
              dangerouslySetInnerHTML={{ __html: formatHtml }}
            />
          </ContentHolder>
        </TAndCStyle>
      </ResponsiveSection>
    </>
  )
}
PageStaticTermsAndConditions.propTypes = {
  html: PropTypes.element.isRequired,
  title: PropTypes.string.isRequired,
}

export default PageStaticTermsAndConditions
